import smartlook from 'smartlook-client'
import { SMARTLOOK_PROJECT } from '../constants'

if (process.env.REACT_APP_API_ENV === 'production') {
  smartlook.init(SMARTLOOK_PROJECT)
  smartlook.pause()
}

export default smartlook
